import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

import AddStudentExam from './AddStudentExam.gql';

export default class AddStudentExamModal extends Component {
  state = {
    modalOpen: false,
  };

  closeModal = () => {
    this.setState(prevState => ({ modalOpen: false }));
  };

  openModal = () => {
    this.setState(prevState => ({ modalOpen: true }));
  };

  renderTrigger = () => {
    return React.cloneElement(this.props.trigger, { onClick: this.openModal });
  };

  render() {
    const { roundCode, locationCode } = this.props;
    return (
      <Modal
        className={'scrolling'}
        trigger={this.renderTrigger()}
        dimmer="inverted"
        open={this.state.modalOpen}
        onClose={this.closeModal}
      >
        <AddStudentExam
          roundCode={roundCode}
          locationCode={locationCode}
          onClose={this.closeModal}
        />
      </Modal>
    );
  }
}
